import { useWindowDimensions } from 'react-native';

// At this width the dock becomes a left rail and long rails wrap instead of scroll.
export const DESKTOP_BREAKPOINT = 1024;
export const useIsDesktop = () => useWindowDimensions().width >= DESKTOP_BREAKPOINT;
